interface Props {
  size?: number;
  className?: string;
}

/**
 * The brand mark — mascot illustration with the "You Done Fucked Up"
 * wordmark baked into the image. Provided by the user, lives in /public.
 *
 * The image is square. Rendered at any size; for tiny sizes the wordmark
 * loses legibility but the silhouette stays recognizable, which is the
 * point — it's a mascot, not a typographic mark.
 */
export function Logo({ size = 38, className = "" }: Props) {
  return (
    <img
      src="/logo.png"
      alt="You Done Fucked Up"
      width={size}
      height={size}
      className={className}
      style={{
        // `size` is the *natural* render width; maxWidth: 100% lets a
        // narrow wrapper (e.g. a phone-width column) shrink the logo
        // proportionally so it never overflows on small screens.
        width: size,
        height: "auto",
        maxWidth: "100%",
        objectFit: "contain",
        display: "inline-block",
      }}
    />
  );
}
